{
  "meta": {
    "business": {
      "title": "money2me — клиенттерді қайтаратын кэшбэк",
      "description": "money2me — бизнеске арналған кэшбэк қызметі. Клиенттер QR арқылы төлеп кэшбэк алады, ал сіз қайта оралатын қонақтарға ие боласыз."
    },
    "app": {
      "title": "money2me — сатып алудан кэшбэк және QR арқылы төлеу",
      "description": "Картаны байланыстырып, QR арқылы төлеңіз және money2me көмегімен сатып алудан кэшбэк алыңыз. Бонустар, сатып алу тарихы және орындар картасы — бір қосымшада."
    },
    "point": {
      "title": "money2me — осы нүктедегі кэшбэк пен акциялар",
      "description": "Осы нүктедегі ұсыныстар, акциялар және сіздің кэшбэгіңіз — money2me қосымшасында."
    }
  },
  "header": {
    "nav": {
      "label": "Негізгі навигация",
      "toggle": "Мәзірді ашу",
      "close": "Мәзірді жабу",
      "howItWorks": "Бұл қалай жұмыс істейді",
      "advantages": "Артықшылықтар",
      "benefits": "Пайда",
      "faq": "Жиі қойылатын сұрақтар",
      "app": "Қосымша",
      "business": "Сауда нүктелері үшін"
    },
    "cta": {
      "apply": "Өтінім қалдыру",
      "download": "Жүктеу"
    },
    "language": "Тіл"
  },
  "hero": {
    "title": "Клиенттерді қайтаратын кэшбэк",
    "description": "Клиенттер QR арқылы төлеп, сатып алу үшін кэшбэк алады.",
    "mobileDescription": "Картаны байланыстырып, QR арқылы төлеп, 10%-ға дейін кэшбэк алыңыз.",
    "primaryCta": "Бизнесті қосу",
    "secondaryCta": "Пайданы есептеу",
    "categories": [
      "Барлар мен кофеханалар",
      "Кафе мен мейрамханалар",
      "Шаштараздар мен салондар",
      "Дүкендер мен ритейл",
      "Кондитерлік және наубайхана",
      "Дәріханалар",
      "Фитнес пен спорт",
      "Автосервис пен жуу орындары",
      "Гүлдер мен сыйлықтар",
      "Балалар тауарлары",
      "Электроника"
    ]
  },
  "guestJourney": {
    "title": "Сіздің қонағыңыз не істейді",
    "description": "Керегі — тек телефон. Және үш қарапайым қадам:",
    "steps": [
      {
        "title": "Сатып алуды төлейді",
        "description": "Картасын бір рет байланыстырып, QR-кодыңызды сканерлеп төлейді."
      },
      {
        "title": "Бонус алады",
        "description": "Жұмсалған соманың бір бөлігі оған бонус ретінде қайтарылады."
      },
      {
        "title": "Қайта оралады",
        "description": "Бонустарды тек сізде ғана жұмсауға болады — қонақты қайтаратын да осы."
      }
    ]
  },
  "whyMoney2me": {
    "title": "Жарнама клиентті бір рет әкеледі. Ал одан кейін ше?",
    "description1": "Сіз тартымдылыққа төлейсіз, қонақ келеді — және қайтып оралмайды.",
    "description2": "money2me логиканы өзгертеді: сіз көрсетілімге емес, клиенттердің қайта оралуына салым саласыз.",
    "mobileDescription": "money2me жаңа клиенттерді тартады және оларды қайта оралуға көмектеседі.",
    "money2me": {
      "title": "money2me",
      "items": [
        "Кэшбэк клиентті нақ сізге қайта оралуға ынталандырады",
        "Жаңа қонақтар сізді қосымша каталогынан табады",
        "Нүкте мен санат бойынша икемді кэшбэк ставкасы",
        "Әрбір төлем бойынша ашық статистика"
      ]
    },
    "ads": {
      "title": "Әдеттегі жарнама",
      "items": [
        "Клиенттер үшін емес, кликтер мен көрсетілімдер үшін төлейсіз",
        "Қонақ бір рет келіп, сізді ұмытады",
        "Қай жарнама шынымен ақталғаны белгісіз",
        "Нәтижеге кепілдіксіз алдын ала бюджет керек"
      ]
    }
  },
  "howItWorks": {
    "title": "Бизнес үшін бұл қалай жұмыс істейді?",
    "description": "Кассалар, терминалдар және күрделі интеграциялар қажет емес. Стойкада QR-код болса жеткілікті.",
    "steps": [
      {
        "badge": "1-қадам",
        "title": "Өтінім",
        "description": "Қысқа форманы толтырыңыз. Бұл — тіркеусіз және міндеттемесіз алғашқы қадам."
      },
      {
        "badge": "2-қадам",
        "title": "Қосылу",
        "description": "Менеджер деректерді тексеріп, қосылу шарттарын келіседі."
      },
      {
        "badge": "3-қадам",
        "title": "Жариялау",
        "description": "Мекемеңіз каталогта ұсынысыңыз бен кэшбэкпен пайда болады."
      },
      {
        "badge": "4-қадам",
        "title": "Сатып алу және кэшбэк",
        "description": "Қонақ QR арқылы төлейді, кэшбэк алады және қайта оралады."
      }
    ]
  },
  "growthTool": {
    "title": "Тағы бір шығын емес, өсу құралы",
    "description": "Кассалар, терминалдар және күрделі интеграциялар қажет емес. Стойкада QR-код болса жеткілікті.",
    "newClients": {
      "title": "Жаңа клиенттер",
      "description": "Клиенттер кэшбэк алатын жерді іздеп, сізді money2me каталогынан табады."
    },
    "transparentOperations": {
      "title": "Ашық операциялар",
      "description": "Әр нүкте бойынша айналым, қонақтар және орташа чек — бәрі көрінеді."
    },
    "flexibleRate": {
      "title": "Икемді кэшбэк ставкасы",
      "description": "Әр нүкте мен тауар санаты үшін жеке кэшбэк ставкасы."
    },
    "notADiscount": {
      "title": "Кэшбэк, жеңілдік емес",
      "description": "Клиент әдеттегі бағаны көреді, ал кэшбэк сіздің маржаңыздан есептеледі."
    },
    "qrPayment": {
      "title": "QR арқылы картамен төлем",
      "description": "Клиент QR-кодты сканерлеп, картамен төлейді. Терминалсыз және кассасыз."
    },
    "promotions": {
      "title": "Жылжыту және акциялар",
      "description": "Қосымшада акциялар өткізіп, қонақтарды керек сәтте тартыңыз."
    },
    "model": {
      "title": "Модель қалай құрылған?",
      "description": "Әдеттегі баға плюс сіздің маржаңыздан кэшбэк. Клиент таза бағаны көреді, кэшбэк (мысалы, 10%) — бөлек. Бұл кэшбэк, жеңілдік емес.",
      "clientPrice": "Клиент көретін баға",
      "cashbackShare": "Маржаңыздан кэшбэк",
      "clientReturn": "Клиентке қайтарым"
    }
  },
  "stats": {
    "title": "Бұл бизнеске не береді?",
    "items": [
      {
        "value": "10%",
        "label": "Төлем үшін клиентке кэшбэк"
      },
      {
        "value": "×2",
        "label": "Қайта келу жиілігі"
      },
      {
        "value": "+20%",
        "label": "Орташа кіріс өсімі"
      },
      {
        "value": "1 күн",
        "label": "Қосылуға және іске қосуға кетер уақыт"
      }
    ]
  },
  "faq": {
    "title": "Жиі қойылатын сұрақтар",
    "items": [
      {
        "question": "money2me-ге қалай қосылуға болады?",
        "answer": "Өтінім қалдырыңыз — менеджер хабарласып, шарттарды келісіп, баптауға көмектеседі. Тек стойкада QR-код керек, жабдық қажет емес."
      },
      {
        "question": "Әртүрлі кэшбэк орнатуға бола ма?",
        "answer": "Иә. Кэшбэк ставкасын әр нүкте мен тауар немесе қызмет санаты үшін бөлек орнатуға болады."
      },
      {
        "question": "Кэшбэкті кім төлейді?",
        "answer": "Кэшбэк сіздің маржаңыздан — сатып алу құнының бір бөлігі ретінде есептеледі, үстеме жеңілдік ретінде емес."
      },
      {
        "question": "Ақша менің шотыма қалай және қашан түседі?",
        "answer": "Төлемдер қосылу кезінде келісілген төлем кестесі бойынша сіздің есеп шотыңызға түседі."
      },
      {
        "question": "Кез келген уақытта ажыратуға бола ма?",
        "answer": "Иә, money2me арқылы төлем қабылдауды кез келген уақытта айыппұлсыз және міндеттемесіз ажыратуға болады."
      },
      {
        "question": "Клиент ретінде money2me-ні қалай қолданамын?",
        "answer": "money2me қосымшасын орнатыңыз, картаңызды байланыстырыңыз және стойкадағы QR-код арқылы төлеңіз — кэшбэк автоматты түрде есептеледі."
      }
    ]
  },
  "ctaBanner": {
    "title": "money2me-дегі алғашқы мекемелердің бірі болыңыз",
    "description": "Өтінім қалдырыңыз — менеджер хабарласып, сұрақтарға жауап беріп, қосылуға көмектеседі.",
    "cta": "Өтінім қалдыру"
  },
  "footer": {
    "app": {
      "title": "Клиенттеріңізге арналған money2me қосымшасы",
      "description": "QR арқылы картамен төлем, сатып алулар үшін кэшбэк және жақын маңдағы мекемелер картасы. Әдеттегідей төлейсіз — көбірек аласыз.",
      "googlePlay": "Google Play-ден жүктеу",
      "appStore": "App Store-дан жүктеу"
    },
    "brand": {
      "title": "money2me",
      "description": "QR арқылы кэшбэкпен картамен төлем. Қайта оралатын клиенттер."
    },
    "business": {
      "title": "Бизнеске",
      "howItWorks": "Бұл қалай жұмыс істейді",
      "advantages": "Артықшылықтар",
      "apply": "Өтінім қалдыру"
    },
    "appNav": {
      "title": "Қосымша",
      "appStore": "App Store",
      "googlePlay": "Google Play"
    },
    "contacts": {
      "title": "Байланыс",
      "phone": "+7 (700) 000-00-00",
      "email": "business@moneyto.me"
    },
    "copyright": "© 2026 «NEOCODE» ЖШС. Барлық құқықтар қорғалған.",
    "offer": "Оферта",
    "privacy": "Құпиялылық саясаты",
    "cardPayment": "Картамен төлеу шарттары"
  },
  "applyForm": {
    "title": "Өтінім қалдыру",
    "description": "Форманы толтырыңыз — команда хабарласып, тексеруді бастайды",
    "close": "Жабу",
    "back": "Артқа",
    "fields": {
      "contactName": "Байланыс тұлғасы",
      "contactNamePlaceholder": "Мысалы, Айгерим",
      "businessName": "Бизнес атауы",
      "businessNamePlaceholder": "Мысалы, Coffee Boom",
      "phone": "Телефон нөмірі",
      "phonePlaceholder": "+7 (700) 000-00-00",
      "email": "Email",
      "emailPlaceholder": "you@business.kz",
      "businessType": "Бизнес түрі",
      "businessTypeLegalEntity": "Заңды тұлға",
      "businessTypeIndividualEntrepreneur": "ЖК",
      "bin": "БСН",
      "binPlaceholder": "12 сан",
      "category": "Бизнес санаты",
      "categoryPlaceholder": "Санатты таңдаңыз",
      "locationsCount": "Нүктелер саны",
      "locationsCountPlaceholder": "Мысалы, 3",
      "cities": "Қала",
      "citiesPlaceholder": "Алматы",
      "description": "Бизнес сипаттамасы (қалауыңызша)",
      "descriptionPlaceholder": "Бизнесіңіз туралы бірнеше сөз"
    },
    "categories": {
      "FOOD_SERVICE": "Кафе және мейрамханалар",
      "RETAIL": "Азық-түлік және бөлшек сауда",
      "BEAUTY_HEALTH": "Сұлулық және денсаулық",
      "SERVICES": "Қызметтер",
      "FUEL": "ЖҚС",
      "PHARMACY": "Дәріханалар",
      "FASHION": "Киім және аяқ киім",
      "ELECTRONICS": "Электроника",
      "ENTERTAINMENT": "Ойын-сауық және демалыс",
      "OTHER": "Басқа"
    },
    "cities": {
      "ALMATY": "Алматы"
    },
    "consent": "<policy>Құпиялылық саясатына</policy> сәйкес дербес деректерді өңдеуге келісемін",
    "submit": "Өтінімді жіберу",
    "submitting": "Жіберілуде…",
    "errors": {
      "required": "Бұл өрісті толтырыңыз",
      "tooLong": "150 таңбадан аспауы керек",
      "phone": "Телефон нөмірін дұрыс енгізіңіз",
      "email": "Email-ды дұрыс енгізіңіз",
      "emailLength": "Email тым ұзын",
      "bin": "Дұрыс БСН енгізіңіз (12 сан)",
      "category": "Бизнес санатын таңдаңыз",
      "city": "Қаланы таңдаңыз",
      "locationsCount": "Кемінде бір нүктені көрсетіңіз",
      "descriptionTooLong": "500 таңбадан аспауы керек",
      "consent": "Дербес деректерді өңдеуге келісім қажет",
      "submit": "Өтінімді жіберу мүмкін болмады. Қайталап көріңіз."
    },
    "success": {
      "title": "Өтінім жіберілді",
      "description": "Рахмет! Біз сіздің өтініміңізді алдық және қосылуды талқылау үшін сізбен хабарласамыз.",
      "cta": "Жақсы"
    }
  },
  "appHero": {
    "titleLine1": "Әдеттегідей төлеңіз —",
    "titleLine2": "ақшаны қайтарып алыңыз",
    "descriptionLine1": "Картаны байланыстырып, QR арқылы төлеп,",
    "descriptionLine2": "10%-ға дейін кэшбэк алыңыз."
  },
  "appHowTo": {
    "title": "Кэшбэкті қалай ала бастау керек",
    "description": "Қосымшаны жүктеп, картаны байланыстырыңыз да, сатып алулар үшін кэшбэк алыңыз — анкетасыз және жаңа пластик картасыз.",
    "steps": [
      {
        "title": "Қосымшаны жүктеңіз",
        "description": "money2me.app-ты орнатып, телефон нөмірі бойынша бір минутта тіркеліңіз."
      },
      {
        "title": "Картаны байланыстырыңыз",
        "description": "Кез келген банктің картасын қосыңыз. Жаңасын шығарып, анкета толтырудың қажеті жоқ."
      },
      {
        "title": "QR арқылы төлеңіз",
        "description": "Кассадағы QR-кодты сканерлеп, соманы тексеріп, төлемді растаңыз."
      },
      {
        "title": "Кэшбэк алыңыз",
        "description": "Соманың бір бөлігі бонуспен қайтады. Оны чектің 100%-ына дейін төлеуге болады."
      }
    ]
  },
  "appMoreCashback": {
    "title": "Апта сайын көбірек кэшбэк",
    "description": "Стористегі ұсыныстарды қадағалап, жоғары кэшбэкті орындарды табыңыз.",
    "offers": [
      {
        "badge": "Кэшбэк 7%",
        "label": "Күтім мен сұлулыққа"
      },
      {
        "badge": "Кэшбэк 5%",
        "label": "12:00-ге дейін кофеге"
      },
      {
        "badge": "Кэшбэк 7%",
        "label": "Спорт пен фитнеске"
      },
      {
        "badge": "Кэшбэк 5%",
        "label": "Кешке тағам жеткізуге"
      },
      {
        "badge": "Бонус ×3",
        "label": "Демалыс күндері азық-түлікке"
      },
      {
        "badge": "Кэшбэк 7%",
        "label": "Себепсіз гүлдерге"
      },
      {
        "badge": "Кэшбэк 7%",
        "label": "Балалар тауарларына"
      },
      {
        "badge": "Кэшбэк 3%",
        "label": "Кино билеттеріне"
      },
      {
        "badge": "Кэшбэк 10%",
        "label": "Демалыс күндері бүкіл мәзірге"
      }
    ]
  },
  "appFeatures": {
    "title": "Керектің бәрі — бір қосымшада",
    "description": "Кэшбэктің барлық құралы қол астында: бонустар, сатып алу тарихы және жақын маңдағы мекемелер картасы.",
    "items": [
      {
        "title": "Бонус — бұл ақша",
        "descriptionLine1": "Келесі чектің 100%-ына дейін",
        "descriptionLine2": "бонуспен төлеңіз."
      },
      {
        "title": "Чектер мен тарих",
        "descriptionLine1": "Барлық сатып алулар мен электрондық",
        "descriptionLine2": "чектер қосымшада сақталады."
      },
      {
        "title": "Жақын маңдағы нүктелер картасы",
        "descriptionLine1": "Кэшбэгі бар орындарды",
        "descriptionLine2": "жақыннан картадан табыңыз."
      },
      {
        "title": "Досыңды шақыр",
        "descriptionLine1": "Достарыңызды шақырыңыз —",
        "descriptionLine2": "бонусты екеуіңіз де аласыз."
      },
      {
        "title": "Кез келген банктің картасы",
        "descriptionLine1": "Секундтарда байланысады.",
        "descriptionLine2": "Бүкіл money2me желісінде төлеуге болады."
      },
      {
        "title": "QR арқылы төлем",
        "descriptionLine1": "Кассадағы кодты сканерлеп,",
        "descriptionLine2": "соманы растаңыз."
      }
    ]
  },
  "appWhyInstall": {
    "title": "Қосымшаны неге орнату керек",
    "description": "Кассалар, терминалдар және күрделі интеграциялар қажет емес. Стойкада QR-код болса жеткілікті.",
    "items": [
      {
        "value": "70%-ға дейін",
        "label": "сатып алудан кэшбэк"
      },
      {
        "value": "100%-ға дейін",
        "label": "бонуспен төлеуге болады",
        "mobileLabel": "бонуспен төлем"
      },
      {
        "value": "×2",
        "label": "акциялардағы кэшбэк"
      },
      {
        "value": "1 минут",
        "label": "тіркелуге"
      }
    ]
  },
  "appFaq": {
    "title": "Жиі қойылатын сұрақтар",
    "items": [
      {
        "question": "QR арқылы қалай төлеуге болады?",
        "answer": "money2me-ні ашып, кассадағы QR-ды сканерлеп, соманы растаңыз. Төлем байланыстырылған картадан өтеді."
      },
      {
        "question": "Бонустар қашан түседі?",
        "answer": "Сатып алу бонустары төлемнен кейін бірден автоматты түрде есептеледі."
      },
      {
        "question": "Бүкіл чекті бонуспен төлеуге бола ма?",
        "answer": "Иә, келесі чектің 100%-ына дейін бонуспен төлеуге болады."
      },
      {
        "question": "Ақша шотыма қалай және қашан түседі?",
        "answer": "Кэшбэк қосымшада бонуспен есептеледі және серіктестерден сатып алуға бірден қолжетімді."
      },
      {
        "question": "Бұл тегін бе?",
        "answer": "Иә. Клиенттерге money2me-ні орнату мен пайдалану тегін — тек сатып алуларға төлейсіз."
      }
    ]
  },
  "appCta": {
    "titleLine1": "Әр сатып алудан",
    "titleLine2": "ақшаңызды қайтара бастаңыз",
    "description": "money2me-ні орнатыңыз — телефон нөмірі бойынша бір минутта тіркелу.",
    "cta": "Қосымшаны жүктеу"
  },
  "downloads": {
    "unavailable": "Жақында"
  },
  "pointQr": {
    "home": "money2me — басты бетке",
    "title": "Кэшбэк пен акциялар",
    "titleAccent": "осы нүктеде",
    "description": "Нүктенің ұсыныстары мен сіздің кэшбэгіңіз — money2me қосымшасында.",
    "android": {
      "rescan": "Қосымшаны орнатқаннан кейін QR-кодты қайта сканерлеңіз — нүкте қосымшада ашылады.",
      "openAppHint": "Қосымша орнатылған ба?",
      "openApp": "Қосымшада ашу"
    },
    "ios": "iPhone-ға арналған қосымша жақында App Store-да шығады. Әзірге money2me Android-та қолжетімді.",
    "desktop": "Бұл бетті Android телефонында ашыңыз немесе қосымшаны Google Play-ден жүктеңіз.",
    "invalid": {
      "title": "QR-кодты тану мүмкін болмады",
      "description": "money2me қосымшасын орнатып, нүктені қосымшадағы картадан табыңыз."
    },
    "about": "money2me туралы толығырақ"
  },
  "notFound": {
    "title": "Мұндай бет жоқ",
    "description": "Сілтеме ескірген немесе қате жазылған болуы мүмкін. money2me басты бетінен бастаңыз.",
    "home": "Басты бетке"
  }
}
